import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { post } from 'axios';
import { cocktailActions } from '../_actions';
import { Spinner } from '../Spinner';
import { history } from '../_helpers';
import { IngredientSlide } from '../IngredientSlide';
import HorizontalScroll from 'react-scroll-horizontal'

class AddRecipe extends React.Component {
  constructor(props) {
    super(props);

    const { recipes } = props;
    if (props.match.params.machine_name && recipes.items) {
      let machine_name = props.match.params.machine_name
      this.loadRecipe(recipes, machine_name);
    } else {

      this.state = {
        recipe: {
          name: '',
          category: 'Sweet',
          glassware: 'Highball glass',
          measurements: '',
          recipe_url: '',
          ingredients: [],
          _id: ''
        },
        img_blob_url: '',
        submitted: false,
        fetchInProgress: false
      };
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.onImageUploadFormSubmit = this.onImageUploadFormSubmit.bind(this);
    this.onImageUploadChange = this.onImageUploadChange.bind(this);
    this.imageUpload = this.imageUpload.bind(this);
    this.removeFromRecipe = this.removeFromRecipe.bind(this)

  }

  componentDidMount() {
    this.props.dispatch(cocktailActions.getAllIngredients());
  }

  loadRecipe(recipes, machine_name) {

    if (!machine_name) {
      machine_name = window.location.pathname.split("/").slice(-2)[0];
    }

    if (!('items' in recipes) || !(recipes.items instanceof Array)) {
      history.push('/');
    }

    const isRecipe = p => p.machine_name === machine_name
    const recipe = recipes.items.find(isRecipe)

    if (!recipe) {
      return <div>Sorry, but the recipe was not found</div>
    }

    let img_blob_url = recipe.img_url.substring(0,4) != 'data' ? 'data:image/png;base64,' + recipe.img_url : recipe.img_url;

    this.state = {
      recipe: {
        ...recipe,
        img_url: ''
      },
      img_blob_url: img_blob_url,
      submitted: false,
      fetchInProgress: false,
      original_name: recipe.name
    };
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.ingredients.items) {
      const toDelete = new Set(this.state.recipe.ingredients);
      const storeShelves = nextProps.ingredients.items.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));
      this.setState({
        storeShelves: storeShelves
      })
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    console.log("Where is name & value: ", event.target, event);
    const { recipe } = this.state;
    this.setState({
      recipe: {
        ...recipe,
        [name]: value
      }
    });
  }

  onImageUploadFormSubmit(e){
    e.preventDefault() // Stop form submit
    this.imageUpload(this.state.file).then((response)=>{
      console.log("Here is the image upload response data:", response.data);
      const { recipe } = this.state;
      this.setState({
        img_blob_url: response.data.img_url,
        recipe: {
          ...recipe,
          ['_id']: response.data._id
        }
      });
    })
  }


  b64toBlob(b64Data, contentType='', sliceSize=512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  blobToString(b) {
    let u, x;
    u = URL.createObjectURL(b);
    x = new XMLHttpRequest();
    x.open('GET', u, false); // although sync, you're not fetching over internet
    x.send();
    URL.revokeObjectURL(u);
    return x.responseText;
  }


  onImageUploadChange(e) {
    //this.setState({file:e.target.files[0]})  this.state.file

    // before making call, set fetch flag
    this.setState({ fetchInProgress: true });

    this.imageUpload(e.target.files[0]).then((response)=>{


      console.log("Here is the image upload response data:", response.data);

      // revolutionary:
      //const contentType = 'image/png';
      //const blob = this.b64toBlob(response.data, contentType);
      //const blobUrl = URL.createObjectURL(blob);

      //const img = document.createElement('img');
      //img.src = blobUrl;
      //document.body.appendChild(img);
      // end revolutionary

      const {recipe} = this.state;
      this.setState({
        fetchInProgress: false,
        img_blob_url: 'data:image/png;base64,' + response.data.img_url,
        recipe: {
          ...recipe,
          ['_id']: response.data._id
        }
      });

    })
  }


  imageUpload(file){

    const { recipe } = this.state;
    //const url = recipe._id? 'https://www.stevebreese.com/Bottleneck-City/api/images/' + recipe._id : 'https://www.stevebreese.com/Bottleneck-City/api/images';
    const url = recipe._id? 'https://fixadrink-api.herokuapp.com/uploads/' + recipe._id : 'https://fixadrink-api.herokuapp.com/uploads';


    const formData = new FormData();

    formData.append('file',file);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    return post(url, formData,config)
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ submitted: true });
    const { recipe, original_name } = this.state;
    recipe.measurements = recipe.measurements.split(',').map(Number);
    console.log("Here is the recipe", recipe);
    const { dispatch } = this.props;
    console.log("We will try to validate this!", recipe);
    if (recipe.name && recipe.category && recipe.glassware && recipe.measurements && recipe.recipe_url && recipe._id) {
      console.log("And we got to dispatch!", recipe);
      dispatch(cocktailActions.addRecipe(recipe, original_name));
    }
  }

  onItemClick(machine_name) {

    const { recipe } = this.state;
    const { ingredients } = this.props;

    let joined = recipe.ingredients.concat(machine_name);
    console.log("Well, here is concat!", joined);

    let recipeNew = {
      ...recipe,
      ['ingredients']: joined
    };
    console.log("onItemClick Here ya go!", recipeNew);
    this.setState({
      recipe: recipeNew
    });

    /* Now remove from store shelves */
    const toDelete = new Set(joined);
    const storeShelvesNew = ingredients.items.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));
    this.setState ({
      storeShelves: storeShelvesNew
    })

    /* Uncomment and replace with recipe if they should be saved upon every click
     const { dispatch } = this.props;
     if (userModifiedNew.first_name && userModifiedNew.last_name && userModifiedNew.email) {
     console.log("Update this now mod!", userModifiedNew);
     dispatch(userActions.update(userModifiedNew));
     }
     */
    //return (e) => this.props.dispatch(userActions.addIngredientToCabinet(machine_name));
    //where 'id' =  whatever suffix you give the data-* li attribute
  }

  removeFromRecipe(machine_name) {
    console.log("Here is mn:", machine_name);
    const { ingredients } = this.props;
    const { recipe } = this.state;

    const toDelete = new Set(machine_name);
    let recipeIngredients = recipe.ingredients.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));
    let index = recipeIngredients.indexOf(machine_name);    // <-- Not supported in <IE9
    if (index !== -1) {
      recipeIngredients.splice(index, 1);
    }
    console.log("Does cabinet have this in Add Recipe?", machine_name, recipeIngredients);

    let recipeNew = {
      ...recipe,
      ['ingredients']: recipeIngredients
    };
    console.log("removeFromRecipe Here ya go!", recipeNew);
    this.setState({
      recipe: recipeNew
    });

    // re-add to store:
    const toDeleteList = new Set(recipeIngredients);
    const storeShelvesNew = ingredients.items.filter(ingredientItem => !toDeleteList.has(ingredientItem.machine_name));
    this.setState ({
      storeShelves: storeShelvesNew
    })

  }

  render() {
    const { contributing, ingredients, recipes } = this.props;
    const { recipe, submitted } = this.state;

    if (this.props.match.params.machine_name && !recipe.name && recipes.items) {
      let machine_name = this.props.match.params.machine_name
      this.loadRecipe(recipes, machine_name);
    }

    const parent  = { width: `${(this.state.recipe.ingredients.length * 55) - 1}px`, height: `22rem`}

    return (
      <div className="col-md-6 col-md-offset-3">
        <h2>{this.state.original_name?`Edit ${this.state.original_name}`:'Add Recipe'}</h2>
        <form name="form" onSubmit={this.handleSubmit}>
          <div className={'form-group' + (submitted && !recipe.name ? ' has-error' : '')}>
            <label htmlFor="name">Name</label>
            <input type="text" className="form-control" name="name" value={recipe.name} onChange={this.handleChange} />
            {submitted && !recipe.name &&
            <div className="help-block">Name is required</div>
            }
          </div>
          <div className={'form-group' + (submitted && !recipe.category ? ' has-error' : '')}>
            <label htmlFor="category">Category which best describes drink</label>
            <select className="form-control" name="category" value={recipe.category} onChange={this.handleChange}>
              <option value="Sweet">Sweet</option>
              <option value="Bitter">Bitter</option>
              <option value="Strong">Strong</option>
              <option value="Creamy">Creamy</option>
              <option value="Frozen">Frozen</option>
              <option value="Other">Other</option>
            </select>
            {submitted && !recipe.category &&
            <div className="help-block">Type is required</div>
            }
          </div>
          <div className={'form-group' + (submitted && !recipe.glassware ? ' has-error' : '')}>
            <label htmlFor="glassware">Preferred Glassware</label>
            <select className="form-control" name="glassware" value={recipe.glassware} onChange={this.handleChange}>
              <option value="Highball glass">Highball glass</option>
              <option value="Collins glass">Collins glass</option>
              <option value="Old-Fashioned glass">Old-Fashioned glass</option>
              <option value="Martini glass">Martini glass</option>
              <option value="Shot glass">Shot glass</option>
              <option value="Wine glass">Wine glass</option>
            </select>
            {submitted && !recipe.glassware &&
            <div className="help-block">Glassware is required</div>
            }
          </div>

          <div className={'form-group' + (submitted && !recipe.recipe_url ? ' has-error' : '')}>
            <label htmlFor="recipe_url">Recipe URL</label>
            <input type="text" className="form-control" name="recipe_url" value={recipe.recipe_url} onChange={this.handleChange} />
            {submitted && !recipe.recipe_url &&
            <div className="help-block">Recipe URL is required</div>
            }
          </div>

          <div className={'form-group' + (submitted && !recipe.img_url ? ' has-error' : '')}>
            <label htmlFor="img_url">Drink Image</label>
            <div>
              <label for="image_upload_input">

                {this.state.img_blob_url ? (
                  <img src={this.state.img_blob_url} alt="img"/>
                ) : (
                  <div class="btn btn-default btn-circle"><i class="fa fa-image"></i></div>
                )}
                <input type="file" id="image_upload_input" onChange={this.onImageUploadChange} />
              </label>
            </div>
          </div>

          <div className={'form-group' + (submitted && !recipe.measurements ? ' has-error' : '')}>
            <label htmlFor="measurements">Measurements in centiliters (comma separated list)</label>
            <input type="text" className="form-control" name="measurements" value={recipe.measurements} onChange={this.handleChange} />
            {submitted && !recipe.measurements &&
            <div className="help-block">Measurements is required</div>
            }
          </div>

          <div className={'form-group' + (submitted && !recipe._id ? ' has-error' : '')}>
            <input type="hidden" className="form-control" name="_id" value={recipe._id} onChange={this.handleChange} />
            {submitted && !recipe._id &&
            <div className="help-block">Image Thumbnail is required</div>
            }
          </div>

          <label>Ingredients</label>
          <div className="container" id="user_cabinet">

            {ingredients.loading && <em>Loading ingredients...</em>}
            {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
            {ingredients.items && this.state.recipe.ingredients &&
            <div style={parent}>
              <HorizontalScroll>
                {this.state.recipe.ingredients.map((myIngredient, index) =>
                  <IngredientSlide key={myIngredient} match={myIngredient} ingredients={ingredients} showRecipeRemove={true} removeFromRecipe={this.removeFromRecipe}/>
                )}
              </HorizontalScroll>
            </div>
            }

          </div>

          <div className="form-group">
            <button className="btn btn-primary">{this.state.original_name?"Save Changes":"Add Recipe"}</button>
            {contributing &&
            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }
            <Link to="/recipe" className="btn btn-link">Cancel</Link>
          </div>
        </form>

        <div><h3>Click on the drink's ingredients.</h3><p>Can't find a particular ingredient?
          <Link to="/add_ingredient" className="btn btn-link">Add Ingredient</Link></p>

          {ingredients.loading && <em>Loading ingredients...</em>}
          {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
          <h3>Liquor Store</h3>
          {this.state.storeShelves &&
          <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
            {this.state.storeShelves.map((thisIngredient, index) =>
              <div onClick={() => { this.onItemClick(thisIngredient.machine_name) }} style={{background: `url(${thisIngredient.img_url}) no-repeat center/cover`, position: 'relative', whiteSpace: 'normal', display: 'inline-block', height: `20rem`, cursor: 'pointer', width: '55px'}}>
                <div style={{background: 'rgba(0, 0, 0, 0.5)', color: 'white', padding: '5px', bottom: '0px', position: 'absolute', width: '100%', boxSizing: 'border-box'}}>{thisIngredient.name}</div>
              </div>
            )
            }
          </div>
          }

        </div>


        {this.state.fetchInProgress &&
        <Spinner />
        }
      </div>
    );
  }


}

function mapStateToProps(state) {
  const { recipes, contribution, ingredients } = state;
  const { contributing } = state.contribution;
  const { recipe } = contribution;
  return {
    contributing,
    recipe,
    recipes,
    ingredients
  };
}

const connectedAddRecipe = connect(mapStateToProps)(AddRecipe);
export { connectedAddRecipe as AddRecipe };


// WEBPACK FOOTER //
// ./src/AddRecipe/AddRecipe.jsx